import { useAtom } from '@reatom/npm-react'

import { AsyncStateN } from '@blade/std-lib'
import { AuthDialog } from '@root/shared/ui/auth-modal/auth-dialog'

import { LocalPasswordForm } from './local-password-form'

import type { EnterPasswordController } from '../atoms'
import type { DialogControlProps } from '@root/shared/ui-kit'

type Props = {
  controller: EnterPasswordController
} & DialogControlProps

export const LocalPasswordDialog: React.FC<Props> = ({
  controller,
  open,
  onOpenChange,
}) => {
  const [state] = useAtom(controller.stateAtom)

  return (
    <AuthDialog
      open={open}
      onOpenChange={(open) => {
        if (!open && !AsyncStateN.isSuccess(state)) {
          controller.onCancel()
        }
        onOpenChange?.(open)
      }}
    >
      <LocalPasswordForm
        state={state}
        onSubmit={(password) => {
          controller.onPassword({ password })
        }}
      />
    </AuthDialog>
  )
}
